import React from "react";
import {isMobile} from "../../../App";
import jokeyIcon from "../../../assets/img/jokey.png";
import iconSlash from "../../../assets/feather/slash.svg";
import iconTrash from "../../../assets/feather/trash-2.svg";
import {GetStablemateIcon} from "../components/betting-datatable";
import {isMutualItemPlayable, MutualBetslip, staleReasonOf} from "../../../features/betslip/mutual.service";
import {staleSummaryText, summarizeStale} from "../../../features/betslip/lib/selection-guard";

/** Kapanmış koşu / çekilmiş at yüzünden artık oynanamayan satırların anahtarları. */
function staleSelectionKeys(): Set<string> {
    return new Set(
        MutualBetslip.getCurrentItems()
            .filter((item: any) => !isMutualItemPlayable(item))
            .map((item: any) => `${item.column}-${item.run}-${item.horse}`)
    );
}

/**
 * "Oyna" geçersiz seçim yüzünden kilitliyken SEBEBİ söyler ve ÇIKIŞ YOLU verir.
 *
 * İki şey burada birleşiyor:
 *  - Sebep, at numarasıyla: "3. koşuda 1 numaralı at koşmaz durumda".
 *  - Kaldırma buraya AYRI bir düğme olarak konmuyor: seçimin kendisine tıklanıp
 *    kaldırılabiliyor (bkz. `add` ve at satırının `disabled` koşulu).
 *
 * Yerleşim: eylem satırının İÇİNE yatay flex kardeşi olarak girince Misli/Oyna düzenini
 * bozuyordu; artık onun ÜSTÜNDE tam genişlikte ince bir şerit (mobil çubukta yüksekliği
 * sabit olduğu için akıştan çıkarılıp üstüne konumlanıyor).
 */
export function MutualStaleWarning() {
    const items = MutualBetslip.getCurrentItems();
    const summary = summarizeStale(items.map((item: any) => ({
        run: item.run,
        horse: item.horse,
        reason: staleReasonOf(item),
    })));
    const text = staleSummaryText(summary);
    if (!text) {
        return null;
    }
    return (
        <div className="betslip-stale-note" role="alert">
            <span className="betslip-stale-note-icon" aria-hidden="true">!</span>
            <span>{text}</span>
        </div>
    );
}

export function MutualSelectionGrid({tabs, runsMap, betSlipLegs, maxHorseSize, emptyTabs}: any) {
    const staleKeys = staleSelectionKeys();
    return (
                                <div className="betslip body betslip-body">
                                    {tabs.map((column: any, keyColumn: number) => {
                                        let columnType = MutualBetslip.getOptions().bettingSubType.label.split('-').length > 1 ? 'run' : 'horse';
                                        let runObject = runsMap[columnType === 'run' ? Number(MutualBetslip.getOptions().bettingSubType.label.split('-')[keyColumn]) : MutualBetslip.getOptions().bettingSubType.id]
                                        let horses = runObject.horses;
                                        let isAddedAllStatus = MutualBetslip.isAddedAll(keyColumn + 1, runObject);

                                        return (<ul key={`betslip-columns-${keyColumn}`}>

                                            <li className="column-no" onClick={() => {
                                                MutualBetslip.setOptions({column: Number(keyColumn + 1)});
                                            }}>{keyColumn + 1}{isMobile && <>. {MutualBetslip.getOptions().bettingType.columnLabel}</>}</li>

                                            {MutualBetslip.getOptions().bettingSubType.label.split('-').length > 1 &&
                                                <li className={`system ${MutualBetslip.isAdded(keyColumn + 1, runObject, "s") !== false ? 'horse-added' : ''}`}
                                                    style={staleKeys.has(`${keyColumn + 1}-${Number(runObject.no)}-s`)
                                                        ? {border: "1px solid var(--bs-danger)"} : undefined}
                                                    onClick={() => {
                                                        MutualBetslip.add(
                                                            keyColumn + 1,
                                                            runObject,
                                                            's',
                                                            'toggle'
                                                        )
                                                    }}>{isMobile ? 'Sistem' : 'S'}</li>}

                                            {!isMobile && <li onClick={() => {
                                                MutualBetslip.addAll(keyColumn + 1, runObject, isAddedAllStatus === false ? 'add' : 'remove');
                                            }}
                                                              className={`all ${isAddedAllStatus === true ? 'selected-all' : ''}`}>H</li>}

                                            {isMobile && betSlipLegs[keyColumn].length === 0 &&
                                                <li className="bg-dark-subtle">
                                                    <i className="d-block text-center">Bu ayak için en az 1 at
                                                        seçmelisiniz!</i>
                                                </li>}

                                            {horses.map((horse: any, keyHorses: number) => {
                                                let horseIsAdded: any = MutualBetslip.isAdded(keyColumn + 1, runObject, horse) !== false ? 'horse-added' : '';

                                                if (isMobile && horseIsAdded !== 'horse-added') {
                                                    return <>
                                                    </>
                                                }
                                                const isStale = staleKeys.has(
                                                    `${keyColumn + 1}-${Number(runObject.no)}-${horse.no}`);
                                                return (<li key={`betslip-columns-horses-${keyHorses}`}
                                                            className={`${!isMobile ? horseIsAdded : ''}`}
                                                            style={isStale ? {border: "1px solid var(--bs-danger)"} : undefined}
                                                            onClick={() => {
                                                                if (!isMobile) {
                                                                    MutualBetslip.add(
                                                                        keyColumn + 1,
                                                                        runObject,
                                                                        horse,
                                                                        'toggle'
                                                                    )
                                                                }
                                                            }}>{horse.run_status !== true ? <>
                                                    <img src={iconSlash} alt="/"/>
                                                </> : <>{horse.no}{isMobile && <> - {horse.name} <GetStablemateIcon
                                                    horse={horse}/> <i
                                                    className={"float-end"}>
                                                    <img alt={"sil"} src={iconTrash} width={14} onClick={() => {
                                                        MutualBetslip.add(
                                                            keyColumn + 1,
                                                            runObject,
                                                            horse,
                                                            'toggle'
                                                        )
                                                    }} className="cursor-pointer float-right"/>
                                                </i>
                                                </>}</>}</li>)
                                            })}

                                            {maxHorseSize > horses.length && [...Array(maxHorseSize - horses.length)].map((horse: any, keyEmptyHorses: number) => {
                                                return (
                                                    <li className="emptyHorse"
                                                        key={`betslip-columns-horses-${keyEmptyHorses}`}>
                                                    </li>)
                                            })}
                                        </ul>);

                                    })}

                                    {!isMobile && emptyTabs.map((emptyColumn: any, emptyColumnKey: number) => {
                                        return (<ul className="emptyColumn"
                                                    key={`betslip-emptyColumns-${emptyColumnKey}`}>
                                            <li className="column-no">{emptyColumn}</li>
                                            {MutualBetslip.getOptions().bettingSubType.label.split('-').length > 1 &&
                                                <li className="system">S</li>}
                                            <li className="all">H</li>
                                            {[...Array(maxHorseSize)].map((horse: any, keyEmptyHorses: number) => {
                                                return (
                                                    <li className="emptyHorse"
                                                        key={`betslip-columns-horses-${keyEmptyHorses}`}>
                                                    </li>)
                                            })}
                                        </ul>);
                                    })}
                                </div>
    );
}

export function MutualCouponSummary({tabs, runsMap, hippodrome, agfPool}: any) {
    return (
                    <>
                        {tabs.map((column: any, keyColumn: number) => {
                            let columnType = MutualBetslip.getOptions().bettingSubType.label.split('-').length > 1 ? 'run' : 'horse';
                            let runObject = runsMap[columnType === 'run' ? Number(MutualBetslip.getOptions().bettingSubType.label.split('-')[keyColumn]) : MutualBetslip.getOptions().bettingSubType.id]
                            let horses = runObject.horses;
                            return <div>
                                <div className="coupon-subtitle">
                                    <span
                                        className="text-xxsmall">{MutualBetslip.getOptions().bettingType.columnLabel === 'Ayak' || MutualBetslip.getOptions().bettingType.columnLabel === 'At' ? keyColumn + 1 : runObject.no}. {MutualBetslip.getOptions().bettingType.columnLabel}</span>
                                    <span>{runObject.no}.KOŞU - {MutualBetslip.getOptions().hippodrome.runsMap[runObject.no].time}</span>
                                </div>
                                {horses.map((horse: any, keyHorses: number) => {
                                    let horseIsAdded: any = MutualBetslip.isAdded(keyColumn + 1, runObject, horse) !== false ? 'horse-added' : '';
                                    if (horseIsAdded !== 'horse-added') {
                                        return <></>
                                    }
                                    return (<div className={"slip-item"}>

                                        <div className={"d-flex"}>
                                            <img
                                                src={`https://medya-cdn.tjk.org/formaftp/${horse.owner.code}.jpg`}
                                                onError={({currentTarget}) => {
                                                    currentTarget.onerror = null;
                                                    currentTarget.src = jokeyIcon;
                                                }} width={25} height={25} alt={horse.jokey.short_name}
                                                className="jockey-uniform float-start  me-1"/>
                                            <div className={"d-flex flex-column"} style={{gap: "6px"}}>
                                                                <span
                                                                    className="text-small fw-regular">{horse.no} - {horse.name}</span>
                                                <span
                                                    className="text-xxsmall text-light">AGF: %{horse[`agf_ratio${agfPool}`]} ({horse[`agf_sort_no${agfPool}`]})</span>
                                            </div>

                                        </div>

                                        <div className={"d-flex align-items-center"}>
                                            <div className={"me-2"}>
                                                                <span
                                                                    className={"text-xsmall text-light"}>{horse.jokey.short_name}</span>
                                            </div>
                                            <div onClick={() => {
                                                MutualBetslip.remove(
                                                    keyColumn + 1,
                                                    runObject,
                                                    horse
                                                )
                                            }} className="btn-betslip-delete btn">
                                                Kaldır
                                            </div>
                                        </div>

                                    </div>)
                                })}
                            </div>
                        })}
                    </>
    );
}
